import React from "react"

import FormHelperText from "@mui/material/FormHelperText"
import T from "prop-types"
import { always } from "ramda"

import {
  StyledFormControl,
  StyledInput,
  StyledInputLabel,
  StyledMenuItem,
  StyledSelect,
} from "./components"
import { valueRenderFor } from "./lib"

export const Selector = ({
  autoBlur = false,
  background,
  disabled,
  fontColor,
  helperText = "",
  label,
  isInvalid = false,
  onChange,
  onSelectClick = () => false,
  options = [],
  placeholder,
  value,
  variant = "filled",
  width = "auto",
  ...props
}) => {
  return (
    <StyledFormControl
      className={"CirrusSelector"}
      variant={variant}
      sx={{ m: 1, minWidth: 200 }}
      width={width}
      height={props.height}>
      <StyledInputLabel margin="dense">{label}</StyledInputLabel>

      <StyledSelect
        renderValue={valueRenderFor(
          options,
          placeholder && (typeof placeholder === "function" ? placeholder : always(placeholder)),
        )}
        id="demo-simple-select-standard"
        label={label}
        disableUnderline
        input={
          <StyledInput
            background={background}
            disabled={disabled}
            labeled={!!label}
            fontColor={fontColor}
          />
        }
        value={value}
        onChange={(...args) => {
          autoBlur &&
            setTimeout(() => {
              document.querySelectorAll(".MuiInputBase-input").forEach((node) => node.blur())
            }, 0)
          onChange(...args)
        }}
        {...props}
        MenuProps={{
          sx: {
            ".MuiMenu-list": {
              padding: 0,
            },
            ".MuiPaper-root": {
              marginLeft: width !== "auto" && width > 200 ? 0 : "14px",
              marginTop: "-45px",
            },
          },
        }}
        background={background}
        variant={variant}>
        {options.map((option) => (
          <StyledMenuItem key={option.value} value={option.value}>
            {option.title}
          </StyledMenuItem>
        ))}
      </StyledSelect>
      <FormHelperText error={isInvalid}>{helperText}</FormHelperText>
    </StyledFormControl>
  )
}

Selector.propTypes = {
  background: T.string,
  disabled: T.bool,
  fontColor: T.string,
  helperText: T.string,
  label: T.string,
  onChange: T.func,
  options: T.arrayOf(T.shape({ disabled: T.bool, title: T.string.isRequired, value: T.any })),
  value: T.any,
}
